<!-- 底部挂号组件 -->
<template>
    <div class="footmenu">
        <div class="footmenu-left">
            <div class="footmenu-index">
                <img src="@/assets/icon/sy.png" @click="GoIndex" alt="" srcset="">
                <span>首页</span>
            </div>

            <div class="footmenu-tel">
                <img src="@/assets/icon/tel.png" @click="Makephone" alt="" srcset="">
                <span>电话</span>
            </div>
        </div>

        <div class="footmenu-right">
            <div class="footmenu-zixun" @click="Menuclose">在线咨询</div>
            <div class="footmenu-guaho" @click="Menuclose">预约挂号</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
        Menuclose() {
            this.$emit("closePopu", true)
        },
        GoIndex() {
            this.$oneRouter("/")
        },
        Makephone() {
            let Information = JSON.parse(this.$getVal("Information"))
            this.$Telephone(Information.telephone)
        }
    }
}
</script>

<style lang="scss" scoped>
.footmenu {
    background-color: #edfbfb;
    width: 100%;
    height: 66px;
    border-top: 1px solid #DADADA;
    margin: 0 auto;
    position: fixed;
    left: 0;
    bottom: 0px;
    z-index: 99;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .footmenu-right {
        flex: 1;
        margin-left: 30px;
        display: flex;
        justify-content: space-between;

        .footmenu-zixun {
            width: 120px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 4px;
            background-color: #f78535;
            font-size: 12px;
            color: #fff;
        }

        .footmenu-guaho {
            width: 120px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            border-radius: 4px;
            background-color: #62abf2;
            font-size: 12px;
            color: #fff;
        }
    }

    .footmenu-left {
        display: flex;
        align-items: center;

        .footmenu-tel {
            margin-left: 10px;
            margin-left: 20px;
        }

        .footmenu-index,
        .footmenu-tel {
            display: flex;
            flex-direction: column;
            align-items: center;

            img {
                width: 20px;
                height: 20px;
            }

            span {
                font-size: 12px;
                color: #333;
                margin-top: 5px;
            }
        }
    }
}
</style>